export const QUOTED_ITEMN_AND_SERVICES = 'quotedItemAndServices'
// TODO: Fix typo on 'FreeAlignmentTooltip'
export const FREE_ALIGNMENT_TOOLTIP = 'freeAligmentTooltip'
